import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { SignedIn, SignedOut } from "@clerk/clerk-react";

import { hasClerk } from "./clerk";

// Gates a route behind a signed-in Clerk session. When Clerk isn't
// configured (dev-bypass build) the children render unconditionally so
// /play keeps working with `LUCID_AUTH_DEV_BYPASS=1` on the backend.
export default function RequireAuth({ children }: { children: ReactNode }) {
  if (!hasClerk()) return <>{children}</>;
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <Navigate to="/sign-in" replace />
      </SignedOut>
    </>
  );
}
